// import Meta from 'vue-meta';
import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { PROFILE_TYPES } from '@/utils/enums';
import store from '@/store';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                top: 80,
                behavior: 'smooth',
            };
        }

        if (savedPosition) {
            return savedPosition;
        }

        return {
            top: 0,
        };
    },
});

let isFirstLoad = true;

async function beforeEach(to, from, next) {
    const requiredAuth = to.meta?.auth ?? false;
    const allowRoles = to.meta?.allowRoles;

    if (isFirstLoad) {
        isFirstLoad = false;

        try {
            await store.dispatch('auth/checkAuth');
        } catch (error) {
            if (requiredAuth) {
                const isRootPath = to.path === '/';
                const isInternalRedirect = to.fullPath.startsWith('/');
                const safeRedirect = isRootPath ? undefined : isInternalRedirect ? to.fullPath : '/';

                return next({ name: 'login', query: { redirect: safeRedirect } });
            }
        }
    }

    const isAuthenticated = store.getters['auth/isAuthenticated'];
    const userRoles = store.getters['profile/userRoles'] ?? [];

    if (!requiredAuth && isAuthenticated && to.name !== 'device-blocked') {
        return next({ name: 'home' });
    }

    if (requiredAuth) {
        if (!isAuthenticated) {
            const isRootPath = to.path === '/';
            const isInternalRedirect = to.fullPath.startsWith('/');
            const safeRedirect = isRootPath ? undefined : isInternalRedirect ? to.fullPath : '/';

            return next({ name: 'login', query: { redirect: safeRedirect } });
        }

        if (allowRoles) {
            const hasRole = allowRoles.some((role) => userRoles.includes(role));

            if (!hasRole) {
                return next({ name: '403' });
            }
        }
        if (to.name.includes('developer')) {
            const isDeveloperQualified = store.getters['profile/isDeveloperQualified'];

            if (!isDeveloperQualified && to.name !== 'developer.home') {
                return next({ name: 'qualification', params: { type: PROFILE_TYPES.DEVELOPER } });
            }
        }

        return next();
    }

    next();
}

router.beforeEach(beforeEach);

export default router;
